// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_a1-0";